// extracted by mini-css-extract-plugin
module.exports = {"leftPanel":"PlatformConsentAcceptanceSkeleton_leftPanel__LWHml","avatar":"PlatformConsentAcceptanceSkeleton_avatar__DTRtj"};